import { Listbox } from '@headlessui/react';
import { TLeoFeedbackTab } from '../../../../interfaces/tips-feedback/ITipsFeedback';

const options: { value: TLeoFeedbackTab; label: string }[] = [
    { value: 'tips', label: 'Tips' },
    { value: 'links', label: 'Links' },
    { value: 'challenge', label: 'Challenge' },
];

const FeedbackTypeSelect = ({ value, onChange }: {
    value: TLeoFeedbackTab;
    onChange: (value: TLeoFeedbackTab) => void;
}) => (
    <Listbox value={value} onChange={onChange}>
        {({ open }) => (
            <div className='relative w-full sm:w-[240px]'>
                <Listbox.Button aria-label='Feedback type'
                    className={`flex min-h-[48px] w-full items-center gap-2 rounded-full border bg-white px-5 py-3 text-left text-sm shadow-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-2 dark:bg-black dark:focus-visible:ring-offset-gray-900 ${open ? 'border-green-700 dark:border-green-400' : 'border-gray-200 hover:border-gray-400 dark:border-gray-700 dark:hover:border-gray-500'}`}>
                    <span className='text-gray-500 dark:text-gray-400'>Showing:</span>
                    <span className='flex-1 font-medium text-gray-900 dark:text-white'>{options.find((option) => option.value === value)?.label}</span>
                    <svg aria-hidden='true' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'
                        className={`shrink-0 text-gray-600 transition-transform dark:text-gray-300 ${open ? 'rotate-180' : ''}`}><path d='m6 9 6 6 6-6' /></svg>
                </Listbox.Button>
                <Listbox.Options className='absolute right-0 z-40 mt-2 w-full overflow-hidden rounded-2xl border border-gray-200 bg-white p-1.5 shadow-lg focus:outline-none dark:border-gray-700 dark:bg-gray-900'>
                    {options.map((option) => (
                        <Listbox.Option key={option.value} value={option.value}
                            className={({ active }) => `flex min-h-[44px] cursor-pointer items-center justify-between gap-3 rounded-xl px-3 py-2.5 text-sm transition-colors ${active ? 'bg-green-50 text-green-900 dark:bg-green-900/30 dark:text-green-200' : 'text-gray-700 dark:text-gray-200'}`}>
                            {({ selected }) => <>
                                <span className={selected ? 'font-semibold text-green-800 dark:text-green-300' : 'font-medium'}>{option.label}</span>
                                {selected && <svg aria-hidden='true' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' className='text-green-700 dark:text-green-300'><path d='m5 12 4 4L19 6' /></svg>}
                            </>}
                        </Listbox.Option>
                    ))}
                </Listbox.Options>
            </div>
        )}
    </Listbox>
);

export default FeedbackTypeSelect;
